import { Navigate } from 'react-router-dom';

import { createSearchUrl } from 'app/views/layout/views/search/utils';
import { useAppSearchParams } from 'utils/url/useAppSearchParams';

import { transformConversationsParamsToSearchApiArg } from './utils/useConversationsParamsToApiArg/utils/transformConversationsParamsToSearchApiArg';

/**
 * Redirects from the legacy `/conversations` route to `/search/conversations`,
 * translating conversations query parameters to search equivalents.
 */
export const ConversationsRedirectToSearch = (): JSX.Element => {
  const { params } = useAppSearchParams('/conversations');

  const { filters, sortBy, page } = transformConversationsParamsToSearchApiArg(
    params,
    { enrichStatus: false },
  );

  const url = createSearchUrl({
    scope: 'conversations',
    query: '',
    filters: filters ?? { strategy: 'all', filters: [] },
    sortBy,
    page,
    isStrict: false,
  });

  return <Navigate to={url} replace />;
};
